<template>
  <v-container>
    <!-- Mes del periodo centrado -->
    <v-row justify="center">
      <v-col cols="10">
       

        <v-row>
          <v-col cols="12">
            <h3>Gastos por categoría</h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div v-if="categorias.length > 0">
              <v-list color="transparent" class="pa-0 mt-4">
                <v-list-item
                  v-for="categoria in categorias"
                  :key="categoria.categoria"
                  @click="verDetalles(categoria)"
                  class="hoverable"
                >
                  <v-list-item-avatar>
                    <v-icon :color="categoria.color"
                      >mdi-checkbox-multiple-blank-circle</v-icon
                    >
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{
                      categoria.categoria
                    }}</v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action class="d-flex align-center">
                    <span class="mr-2">
                      {{ categoria.acumulado | convertPesoArg }}
                      <v-icon>mdi-chevron-right</v-icon>
                    </span>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </div>
            <div v-else class="text-center mt-10">
              <h1>$ 0</h1>
              <h3>Sin gastos</h3>
              <p class="subtitle-1">No hay gastos registrados.</p>
            </div>
          </v-col>
        </v-row>

        <!-- Lista de categorías o mensaje vacío -->
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import FechaPeriodoVFilter from "@/components/util/FechaPeriodoVFilter.vue";

export default {
  name: "GastosPorCategoria",
  components: {
    FechaPeriodoVFilter,
  },

  data() {
    return {
      categorias: [],
      categoriaSeleccionada: null,
      dialogVistaPrevia: false,
      egreso: null,
      fechaPeriodo: new Date().toISOString().substr(0, 7), // Formato YYYY-MM
    };
  },
  computed: {
    mesPeriodo() {
      return this.moment(this.fechaPeriodo).format("MMMM YYYY").toUpperCase();
    },
  },
  filters: {
    convertPesoArg(value) {
      return `$ ${new Intl.NumberFormat("de-DE").format(value)}`;
    },
  },

  methods: {
    verDetalles(categoria) {
      this.$router
        .push({
          name: "pos.egresos.gastos.detail",
          params: { categoria: categoria },
          query: {
            ...this.$route.query, // mantiene otros query params si los hubiera
            fechaPeriodo: this.fechaPeriodo,
            categoria: categoria.id,
          },
        })
        .catch(() => {});
      this.$emit("ver-detalles-categoria", categoria);
    },
    handleClick(egreso) {
      this.egreso = egreso;
      this.dialogVistaPrevia = true;
    },
    goToRoute(route) {
      this.$router.push({ name: route }).catch(() => {});
    },
    verDetalleEgreso(egreso) {
      var id = egreso.id;
      this.$router
        .push({ name: "detallePromocion", params: { id: id } })
        .catch(() => {});
    },
    async fetchEgresos() {
      try {
        const params = new URLSearchParams();

        if (this.fechaPeriodo) {
          params.append("fechaPeriodo", this.fechaPeriodo);
        }
        if (this.categoriaSeleccionada && this.categoriaSeleccionada.id) {
          params.append("categoria", this.categoriaSeleccionada.id);
        }

        // ⚡️ Agrega el filtro de sucursal
        const sucursalUUID = this.$route.params.uuid_sucursal;

        if (sucursalUUID) {
          params.append("sucursal_uuid", sucursalUUID);
        }

        const response = await this.axios.get(
          `/egresos/gastos?${params.toString()}`
        );
        this.categorias = response.data;
      } catch (error) {
        console.error("Error al cargar egresos:", error);
      }
    },
  },
  created() {
    this.fetchEgresos();
  },
  watch: {
    fechaPeriodo(value) {
      this.fetchEgresos(value);
    },
    categoriaSeleccionada: {
      handler() {
        this.fetchEgresos();
      },
      deep: true, // si querés observar cambios internos
    },
  },
};
</script>

<style scoped>
.hoverable {
  cursor: pointer;
}
</style>
